// extracted by mini-css-extract-plugin
export default {"textareaContainer":"Textarea_textareaContainer__tLYA6","label":"Textarea_label__kBcw9","textarea":"Textarea_textarea__G+2UR"};